import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=db12f26e&scoped=true"
import script from "./AccountProfile.vue?vue&type=script&lang=js"
export * from "./AccountProfile.vue?vue&type=script&lang=js"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&id=db12f26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db12f26e",
  null
  
)

export default component.exports